import { BeforeYouStartTemplate, ContentBody } from '@templates';
import { useNavigate } from 'react-router-dom';
import { CallToActionCardProps } from '@molecules/CallToActionCard/CallToActionCard';
import { RoutesList } from '../../../../routes/Routes';

import { v4 as uuidv4 } from 'uuid';
import {
  CHAT_LINK_TEXT,
  FORM_LINK_TEXT,
  FORM_LINK_SUBTEXT,
  CHAT_LINK_SUBTEXT,
} from '@constants';
import {
  useSignsBollardsStore,
  resetIssueDetails,
  resetUserDetails,
} from '../../../../hooks/useSignsBollardsStore';

const ASSISTANT_URL = import.meta.env.VITE_ASSISTANT_URL;

export const BeforeYouStart = () => {
  const navigate = useNavigate();
  const { update } = useSignsBollardsStore();

  const contentTitle = 'Report a signs and bollards issue';
  const sessionId = uuidv4();
  const initiateForm = () => {
    resetIssueDetails();
    resetUserDetails();
    update('wantConfirmationEmail', '');
    update('contactUserOption', '');
    update('caseReferenceId', '');
    update('sessionId', sessionId);
    navigate(RoutesList.ISSUE_TYPE);
  };

  const reportItCTA: CallToActionCardProps = {
    linkText: FORM_LINK_TEXT,
    linkSubtext: FORM_LINK_SUBTEXT,
    onClick: initiateForm,
  };

  const reportItAssistantRoute = `${ASSISTANT_URL}?category=signs_and_bollards`;
  const reportItAssistantCTA: CallToActionCardProps = {
    linkText: CHAT_LINK_TEXT,
    linkSubtext: CHAT_LINK_SUBTEXT,
    externalHref: reportItAssistantRoute,
  };

  const callToActionCards = [reportItAssistantCTA, reportItCTA];

  const detailsWeNeedContent = {
    sectionTitle: `To help us resolve the issue, we need to know:`,
    itemList: ['details of the issue', 'the location of the issue'],
  };

  const usefulToIncludeContent = {
    sectionTitle: `It's useful to provide: `,
    itemList: ['photos of the issue', 'your contact details'],
  };

  const bodyContent = [detailsWeNeedContent, usefulToIncludeContent];

  const linkObjectArrays = [
    {
      level: 1,
      title: 'Home',
      href: 'https://www.westminster.gov.uk/',
    },
    {
      level: 2,
      title: 'Report it',
      href: 'https://www.westminster.gov.uk/report-it',
    },
    {
      level: 3,
      title: 'Report a signs and bollards issue',
    },
  ];

  return (
    <BeforeYouStartTemplate
      contentTitle={contentTitle}
      contentSubtext={<ContentBody content={bodyContent} />}
      callToActionCards={callToActionCards}
      linkObjectArrays={linkObjectArrays}
    />
  );
};
